import { useQuery } from '@tanstack/react-query';

import { type GetTMSSettingsRequestParams, getTmsSettingsQueryOptions } from '../data-provider/get-settings';

export const useGetTMSSettings = (params: Partial<GetTMSSettingsRequestParams>) => {
  return useQuery(getTmsSettingsQueryOptions(params));
};
